// Core
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

// Components
import { Icon } from "components/ShellV2";

function Metric({ label, value, icon }) {
  return (
    <div className="rec-dso-metric">
      <div className="rec-dso-metric-top">
        <span className="rec-dso-metric-lbl">{label}</span>
        <Icon name={icon} style={{ fontSize: 18, color: "var(--ink-3)", opacity: 0.6 }} />
      </div>
      <div className="rec-dso-metric-val">{value}</div>
    </div>
  );
}

Metric.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  icon: PropTypes.string.isRequired,
};

function KeyMetrics({ data }) {
  const { t } = useTranslation(["dso"]);

  const fmt = (v) => (v || 0).toLocaleString(undefined, { maximumFractionDigits: 2 });

  const metrics = [
    {
      label: t("kpis.total_grid_injection"),
      value: fmt(data.total_grid_injection),
      icon: "upload",
    },
    {
      label: t("kpis.total_grid_consumption"),
      value: fmt(data.total_grid_consumption),
      icon: "power",
    },
    {
      label: t("kpis.total_energy_surplus"),
      value: fmt(data.total_energy_surplus),
      icon: "wb_sunny",
    },
    {
      label: t("kpis.total_surplus_energy_aggregator"),
      value: fmt(data.total_surplus_energy_aggregator),
      icon: "account_tree",
    },
    {
      label: t("kpis.total_imputed_energy"),
      value: fmt(data.total_imputed_energy),
      icon: "functions",
    },
    { label: t("kpis.total_grid_sc"), value: fmt(data.total_grid_sc), icon: "loop" },
    {
      label: t("kpis.total_sharing_energy"),
      value: fmt(data.total_sharing_energy),
      icon: "people",
    },
  ];

  const topRow = metrics.slice(0, 4);
  const bottomRow = metrics.slice(4);

  return (
    <div className="rec-card rec-dso-metrics">
      <div
        className="rec-dso-metric-row"
        style={{ gridTemplateColumns: "repeat(4, minmax(0, 1fr))" }}
      >
        {topRow.map((m) => (
          <Metric key={m.label} {...m} />
        ))}
      </div>
      <div className="rec-dso-metric-div" />
      <div
        className="rec-dso-metric-row"
        style={{ gridTemplateColumns: "repeat(3, minmax(0, 1fr))" }}
      >
        {bottomRow.map((m) => (
          <Metric key={m.label} {...m} />
        ))}
      </div>
    </div>
  );
}

KeyMetrics.defaultProps = {
  data: {
    total_grid_injection: 0,
    total_grid_consumption: 0,
    total_energy_surplus: 0,
    total_surplus_energy_aggregator: 0,
    total_imputed_energy: 0,
    total_grid_sc: 0,
    total_sharing_energy: 0,
  },
};

KeyMetrics.propTypes = {
  data: PropTypes.shape({
    total_grid_injection: PropTypes.number,
    total_grid_consumption: PropTypes.number,
    total_energy_surplus: PropTypes.number,
    total_surplus_energy_aggregator: PropTypes.number,
    total_imputed_energy: PropTypes.number,
    total_grid_sc: PropTypes.number,
    total_sharing_energy: PropTypes.number,
  }),
};

export default KeyMetrics;
